/* eslint-disable @typescript-eslint/no-explicit-any */
import { RouterName } from "@/enums/RouterEnum";
import type { Router, RouteLocationNormalized } from "vue-router";
import { useStore } from "@/store";
import { logoutButKeep, ssrRoute } from "@/enums/NoNeedLoginPageEnum";
import { reactive } from "vue";
interface RouteState {
  nextRoute: RouteLocationNormalized | null;
  previousRoute: RouteLocationNormalized | null;
}
export const routeState: RouteState = reactive({
  nextRoute: null,
  previousRoute: null,
});

export function beforeEach(router: Router) {
  router.beforeEach(async (_, __, next) => {
    const store = useStore() as any;
    const fullPath = _.fullPath;
    const name = _.name as RouterName;
    if (ssrRoute.includes(name)) {
      return (window.location.href = window.location.origin + `${fullPath}`);
    }
    if (logoutButKeep.includes(name)) {
      return next();
    }

    if (
      (localStorage.getItem("token") === null ||
        localStorage.getItem("userInfo") === null) &&
      window.electronAPI
    ) {
      const haveToken = await window.electronAPI.restoreToken();
      console.log(
        "localStorage.getItem('token')",
        localStorage.getItem("token")
      );
      console.log(
        "localStorage.getItem('userInfo')",
        localStorage.getItem("userInfo")
      );
      console.log(
        "name",
        (localStorage.getItem("token") === null ||
          localStorage.getItem("userInfo") === null) &&
          !logoutButKeep.includes(name),
        name
      );
      if (!haveToken) {
        console.log("token or userInfo is null");
        return next({
          name: RouterName.LOGIN,
          query: {
            returnUrl: fullPath,
          },
        });
      } else {
        store.commit(
          "user/setUserInfo",
          JSON.parse(localStorage.getItem("userInfo") || "{}")
        );
        return next({
          name: RouterName.WELCOME,
        });
      }
    }
    store.commit(
      "user/setUserInfo",
      JSON.parse(localStorage.getItem("userInfo") || "{}")
    );
    if (_.path) {
      if ((window as any)._hmt?.cmd) {
        log.debug("百度统计 CMD");
        (window as any)._hmt?.cmd["94be1ebcd3cc76ce2dabfbefb3db2b7c"]?.push([
          "_trackPageview",
          _.fullPath,
        ]);
      } else if ((window as any)._hmt) {
        log.debug("百度统计 default");
        (window as any)._hmt.push(["_trackPageview", _.fullPath]);
      }
    }
    routeState.nextRoute = _;
    routeState.previousRoute = __;
    if (_.path.indexOf("/dataDetail") === -1) {
      document.title = "典枢";
    }
    next();
  });
  router.afterEach((to) => {
    if ((window as any).gtag) {
      (window as any).gtag("set", "page", to.fullPath); // 你可能想根据请求参数添加其他参数，可以修改这里的 to.fullPath
      (window as any).gtag("send", "pageview");
    }
  });
}
